import { FiPlus, FiMinus } from "react-icons/fi";
import * as S from './styles';

type QuantityCounterServiceProps = {
  initialValue: number;
  onIncrement: () => void;
  onDecrement: () => void;
  disabled?: boolean;
  hasMaxCount?: boolean;
};

export function QuantityCounterService({
  initialValue,
  disabled,
  hasMaxCount,
  onIncrement,
  onDecrement,
}: QuantityCounterServiceProps) {

  function handleAdd() {
    if (hasMaxCount) return;
    onIncrement();
  }

  return (
    <S.Container>
      <S.ButtonAction disabled={disabled} onClick={onDecrement}>
        <FiMinus size={12} />
      </S.ButtonAction>

      <S.WrapperQuantity disabled={disabled}>
        <S.Quantity disabled={disabled}>{initialValue}</S.Quantity>
      </S.WrapperQuantity>

      <S.ButtonAction disabled={disabled} onClick={handleAdd}>
        <FiPlus size={12} />
      </S.ButtonAction>
    </S.Container>
  );
}
